// extracted by mini-css-extract-plugin
export default {"container":"style_container__GY5Y8","notice":"style_notice__DK+ts","actionButtons":"style_actionButtons__g3sS0"};